// Авторизация co-pilot через JWT в URL или localStorage.
// Токен живёт 8 часов. После истечения — нужен новый из S+ (через bridge-страницу).

const STORAGE_KEY = 'copilot_jwt'

export function getToken() {
  return localStorage.getItem(STORAGE_KEY) || null
}

export function setToken(token) {
  if (token) localStorage.setItem(STORAGE_KEY, token)
  else       localStorage.removeItem(STORAGE_KEY)
}

export function clearToken() { setToken(null) }

/** При первом открытии — прочитать ?token=... из URL и сохранить в localStorage. */
export function bootstrapTokenFromUrl() {
  const params = new URLSearchParams(window.location.search)
  const t = params.get('token')
  if (t) {
    setToken(t)
    // Очистим URL чтобы токен не светился в адресной строке
    params.delete('token')
    const search = params.toString()
    const newUrl = window.location.pathname + (search ? '?' + search : '') + window.location.hash
    window.history.replaceState({}, '', newUrl)
  }
}

/** Проверка не истёк ли JWT (грубо, по полю exp в payload). */
export function isTokenValid() {
  const t = getToken()
  if (!t || !t.includes('.')) return false
  try {
    const payloadB64 = t.split('.', 1)[0]
    const payload = JSON.parse(atob(payloadB64.replace(/-/g, '+').replace(/_/g, '/').padEnd(payloadB64.length + (4 - payloadB64.length % 4) % 4, '=')))
    return payload.exp && payload.exp * 1000 > Date.now()
  } catch {
    return false
  }
}

/** Забирает payload (без проверки подписи). */
export function decodeToken() {
  const t = getToken()
  if (!t || !t.includes('.')) return null
  try {
    const payloadB64 = t.split('.', 1)[0]
    return JSON.parse(atob(payloadB64.replace(/-/g, '+').replace(/_/g, '/').padEnd(payloadB64.length + (4 - payloadB64.length % 4) % 4, '=')))
  } catch { return null }
}
